import React, { useState, useEffect } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

const QuillToolbar = ({
  editorData,
  editorValue,
}: {
  editorData: any;
  type: any;
  editorValue: any;
}) => {
  const [value, setValue] = useState(editorValue);
  const Editordata = (e: any) => {
    setValue(e);
    editorData(e);
  };

  useEffect(() => {
    editorData(value);
    if (editorValue != null && value === "") {
      setValue(editorValue);
    }
  }, [editorValue]);

  return (
    <ReactQuill
      theme="snow"
      value={value}
      onChange={(e) => {
        Editordata(e);
      }}
      modules={{
        toolbar: {
          container: [
            [
              { header: "1" },
              { header: "2" },
              { header: [3, 4, 5, 6] },
              { font: [] },
            ],
            [{ size: [] }],
            ["bold", "italic", "underline", "strike", "blockquote"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["link", "video"],
            ["image"],
            ["clean"],
            ["code-block"],
          ],
        },
      }}
    />
  );
};

export default QuillToolbar;
